import { getCountryCode, getCurrencyCode, getDefaultLocale } from "./site";

export const NON_BREAKING_SPACE = " ";

type CurrencyFormatOptions = Pick<
  Intl.NumberFormatOptions,
  "maximumFractionDigits"
>;

export const formatCurrency = (
  number: number | undefined,
  options?: CurrencyFormatOptions
): string => {
  if (typeof number === "undefined") {
    return "";
  }

  if (typeof number === "string") {
    return number;
  }

  const { maximumFractionDigits = 2 } = options || {};

  return new Intl.NumberFormat(`${getDefaultLocale()}-${getCountryCode()}`, {
    style: "currency",
    currency: getCurrencyCode(),
    maximumFractionDigits,
    minimumFractionDigits: Math.min(maximumFractionDigits, 2),
  })
    .format(number)
    .replace(/([,\.]00)(?!\d)/g, "")
    .replaceAll(" ", NON_BREAKING_SPACE);
};

export const formatCurrencyForA11y = (
  number: number | undefined,
  options?: CurrencyFormatOptions
) => {
  return formatCurrency(number, options).replaceAll(/\s/g, "");
};

export const formatSignedCurrency = (
  number: number,
  options?: CurrencyFormatOptions
) => {
  const isPositive = number > 0;
  const isNegative = number < 0;

  const formattedNumber = formatCurrency(number, options);

  if (isPositive) {
    return `+${NON_BREAKING_SPACE}${formattedNumber}`;
  }

  if (isNegative) {
    return `−${NON_BREAKING_SPACE}${formattedNumber
      .replace("−", "")
      .replace("-", "")}`;
  }

  return formattedNumber;
};

export const parseCurrency = (number: string | undefined): number => {
  if (!number) {
    return 0;
  }
  return parseInt(number, 10);
};
